import {
  ANALYTICS_BATCH_MAX,
  ANALYTICS_FLUSH_IDLE_TIMEOUT_MS,
  ANALYTICS_QUEUE_MAX,
  isAnalyticsEnabled
} from './config'
import { postAnalyticsEvents } from './transport'
import type { AnalyticsEventPayload } from './types'

const queue: AnalyticsEventPayload[] = []
let idleTimer: ReturnType<typeof setTimeout> | null = null
let flushing = false
let lifecycleBound = false

function scheduleFlush(): void {
  if (!isAnalyticsEnabled()) return
  if (idleTimer != null) return
  idleTimer = setTimeout(() => {
    idleTimer = null
    void flushAnalyticsQueue()
  }, ANALYTICS_FLUSH_IDLE_TIMEOUT_MS)
}

export function enqueueAnalyticsEvent(event: AnalyticsEventPayload): void {
  if (!isAnalyticsEnabled()) return
  queue.push(event)
  while (queue.length > ANALYTICS_QUEUE_MAX) queue.shift()

  if (queue.length >= ANALYTICS_BATCH_MAX) {
    if (idleTimer != null) {
      clearTimeout(idleTimer)
      idleTimer = null
    }
    void flushAnalyticsQueue()
    return
  }
  scheduleFlush()
}

export async function flushAnalyticsQueue(): Promise<void> {
  if (flushing || !isAnalyticsEnabled()) return
  if (queue.length === 0) return

  flushing = true
  try {
    while (queue.length > 0) {
      const chunk = queue.splice(0, ANALYTICS_BATCH_MAX)
      const ok = await postAnalyticsEvents(chunk)
      if (!ok && import.meta.env.DEV) {
        console.warn('[analytics] flush chunk failed, dropped', chunk.length)
      }
    }
  } finally {
    flushing = false
  }
}

function onVisibilityChange(): void {
  if (document.visibilityState === 'hidden') {
    if (idleTimer != null) {
      clearTimeout(idleTimer)
      idleTimer = null
    }
    void flushAnalyticsQueue()
  } else if (queue.length > 0) {
    scheduleFlush()
  }
}

/** 启动期绑一次：切后台 / 关闭页 flush */
export function bindAnalyticsLifecycle(): void {
  if (lifecycleBound || typeof document === 'undefined') return
  lifecycleBound = true
  document.addEventListener('visibilitychange', onVisibilityChange)
  window.addEventListener('pagehide', () => {
    void flushAnalyticsQueue()
  })
}
